import { adminRoutes } from './adminRoutes'
import { posterRoutes } from './posterRoutes'
import { storageRoutes } from './storageRoutes'
import { adminOrdersRoutes } from './adminOrdersRoutes'
// import { userRoutes } from './userRoutes';

export const privateRoutes = [
  ...adminRoutes,
  ...storageRoutes,
  ...posterRoutes,
  ...adminOrdersRoutes,
]
